/* eslint-disable */
// =============================================================================
// HMS — Registry config
// One source of truth for all 8 disease registries (RegistryHub + RegistryView).
// =============================================================================

export const REGISTRY_TYPES = [
  // ----- HIV / ART -----
  {
    type:        "hiv",
    title:       "HIV / ART",
    description: "ART enrolment, viral load and CD4 follow-up",
    icon:        "mdi mdi-virus",
    color:       "#e74c3c",
    listFn:      "getHivPatients",
    enrollFn:    "enrollHiv",
    dataKey:     "Patients",
    idField:     "hiv_id",
    numberField: "art_number",
    columns: [
      { key: "patient_name",      label: "Patient",     type: "patient" },
      { key: "art_number",        label: "ART No",      type: "mono" },
      { key: "who_stage",         label: "WHO Stage" },
      { key: "regimen_line",      label: "Line" },
      { key: "current_regimen",   label: "Regimen" },
      { key: "last_cd4_count",    label: "CD4" },
      { key: "last_viral_load",   label: "VL" },
      { key: "next_visit_date",   label: "Next Visit", type: "date" },
      { key: "status",            label: "Status",     type: "status" }
    ],
    enrollFields: [
      { name: "art_number",            label: "ART Number *",     type: "text" },
      { name: "enrollment_date",       label: "Enrollment Date",  type: "date" },
      { name: "who_stage",             label: "WHO Stage",        type: "select",
        options: [{value:"",label:"Select..."},{value:"1",label:"1"},{value:"2",label:"2"},{value:"3",label:"3"},{value:"4",label:"4"}] },
      { name: "entry_point",           label: "Entry Point",      type: "select",
        options: [{value:"outpatient",label:"Outpatient"},{value:"inpatient",label:"Inpatient"},{value:"vct",label:"VCT"},{value:"pmtct",label:"PMTCT"},{value:"tb",label:"TB Clinic"},{value:"other",label:"Other"}] },
      { name: "regimen_line",          label: "Regimen Line",     type: "select",
        options: [{value:"first",label:"First"},{value:"second",label:"Second"},{value:"third",label:"Third"}] },
      { name: "current_regimen",       label: "Current Regimen",  type: "text" },
      { name: "regimen_start_date",    label: "Regimen Start",    type: "date" }
    ],
    statusOptions: [
      { value: "active",            label: "Active",            class: "hms-badge-success" },
      { value: "lost_to_followup",  label: "Lost to follow-up", class: "hms-badge-danger" },
      { value: "transferred_out",   label: "Transferred out",   class: "hms-badge-warning" },
      { value: "deceased",          label: "Deceased",          class: "hms-badge-danger" },
      { value: "stopped",           label: "Stopped",           class: "hms-badge-neutral" }
    ]
  },

  // ----- TB -----
  {
    type:        "tb",
    title:       "TB",
    description: "TB case management, DOT, contact tracing & outcomes",
    icon:        "mdi mdi-lungs",
    color:       "#9b59b6",
    listFn:      "getTbPatients",
    enrollFn:    "enrollTb",
    dataKey:     "Patients",
    idField:     "tb_id",
    numberField: "tb_number",
    columns: [
      { key: "patient_name",       label: "Patient",      type: "patient" },
      { key: "tb_number",          label: "TB No",        type: "mono" },
      { key: "case_type",          label: "Case Type" },
      { key: "disease_site",       label: "Site" },
      { key: "bacteriology",       label: "Bact" },
      { key: "treatment_start_date", label: "Started",   type: "date" },
      { key: "expected_end_date",  label: "Expected End", type: "date" },
      { key: "status",             label: "Status",       type: "status" }
    ],
    enrollFields: [
      { name: "tb_number",             label: "TB Number *",        type: "text" },
      { name: "case_type",             label: "Case Type",          type: "select",
        options: [{value:"new",label:"New"},{value:"relapse",label:"Relapse"},{value:"treatment_after_failure",label:"After Failure"},{value:"treatment_after_lfu",label:"After LFU"},{value:"transfer_in",label:"Transfer In"},{value:"other",label:"Other"}] },
      { name: "disease_site",          label: "Disease Site",       type: "select",
        options: [{value:"pulmonary",label:"Pulmonary"},{value:"extrapulmonary",label:"Extra-pulmonary"},{value:"both",label:"Both"}] },
      { name: "bacteriology",          label: "Bacteriology",       type: "select",
        options: [{value:"confirmed",label:"Confirmed"},{value:"clinical",label:"Clinical"},{value:"unknown",label:"Unknown"}] },
      { name: "current_regimen",       label: "Current Regimen",    type: "text" },
      { name: "treatment_start_date",  label: "Treatment Start",    type: "date" },
      { name: "dot_type",              label: "DOT Type",           type: "select",
        options: [{value:"facility",label:"Facility"},{value:"community",label:"Community"},{value:"home",label:"Home"}] },
      { name: "hiv_status",            label: "HIV Status",         type: "select",
        options: [{value:"unknown",label:"Unknown"},{value:"negative",label:"Negative"},{value:"positive",label:"Positive"}] }
    ],
    statusOptions: [
      { value: "on_treatment",    label: "On Treatment",   class: "hms-badge-info" },
      { value: "completed",       label: "Completed",      class: "hms-badge-success" },
      { value: "failed",          label: "Failed",         class: "hms-badge-danger" },
      { value: "lost",            label: "Lost",           class: "hms-badge-danger" },
      { value: "deceased",        label: "Deceased",       class: "hms-badge-danger" },
      { value: "transferred_out", label: "Transferred",    class: "hms-badge-warning" }
    ]
  },

  // ----- MCH -----
  {
    type:        "mch",
    title:       "Maternal & Child Health",
    description: "ANC, delivery, postnatal care",
    icon:        "mdi mdi-mother-heart",
    color:       "#e84393",
    listFn:      "getMchPatients",
    enrollFn:    "enrollMch",
    dataKey:     "Patients",
    idField:     "mch_id",
    numberField: "anc_number",
    columns: [
      { key: "patient_name",     label: "Mother",       type: "patient" },
      { key: "anc_number",       label: "ANC No",       type: "mono" },
      { key: "gravida",          label: "G" },
      { key: "para",             label: "P" },
      { key: "edd",              label: "EDD",          type: "date" },
      { key: "anc_visits_count", label: "ANC Visits" },
      { key: "hiv_status",       label: "HIV" },
      { key: "high_risk",        label: "Risk",         type: "yesno" },
      { key: "status",           label: "Status",       type: "status" }
    ],
    enrollFields: [
      { name: "anc_number",   label: "ANC Number *", type: "text" },
      { name: "gravida",      label: "Gravida (G)",  type: "number" },
      { name: "para",         label: "Para (P)",     type: "number" },
      { name: "lmp",          label: "LMP",          type: "date" },
      { name: "edd",          label: "EDD",          type: "date" },
      { name: "hiv_status",   label: "HIV Status",   type: "select",
        options: [{value:"unknown",label:"Unknown"},{value:"negative",label:"Negative"},{value:"positive",label:"Positive"}] },
      { name: "high_risk",    label: "High Risk?",   type: "checkbox" }
    ],
    statusOptions: [
      { value: "active",       label: "Active",       class: "hms-badge-success" },
      { value: "delivered",    label: "Delivered",    class: "hms-badge-info" },
      { value: "transferred",  label: "Transferred",  class: "hms-badge-warning" },
      { value: "lost",         label: "Lost",         class: "hms-badge-danger" },
      { value: "deceased",     label: "Deceased",     class: "hms-badge-danger" }
    ]
  },

  // ----- CANCER -----
  {
    type:        "cancer",
    title:       "Cancer",
    description: "Oncology registry, staging, treatment modalities",
    icon:        "mdi mdi-clipboard-pulse",
    color:       "#c0392b",
    listFn:      "getCancerPatients",
    enrollFn:    "enrollCancer",
    dataKey:     "Patients",
    idField:     "cancer_id",
    numberField: "cancer_number",
    columns: [
      { key: "patient_name",      label: "Patient",      type: "patient" },
      { key: "cancer_number",     label: "Onc No",       type: "mono" },
      { key: "cancer_type",       label: "Type" },
      { key: "icd_code",          label: "ICD" },
      { key: "primary_site",      label: "Site" },
      { key: "stage",             label: "Stage" },
      { key: "diagnosis_date",    label: "Dx Date",      type: "date" },
      { key: "next_appointment",  label: "Next Appt",    type: "date" },
      { key: "status",            label: "Status",       type: "status" }
    ],
    enrollFields: [
      { name: "cancer_number",  label: "Cancer Number",        type: "text" },
      { name: "cancer_type",    label: "Cancer Type *",        type: "text" },
      { name: "icd_code",       label: "ICD-10 Code",          type: "text" },
      { name: "primary_site",   label: "Primary Site",         type: "text" },
      { name: "stage",          label: "Stage",                type: "select",
        options: [{value:"unknown",label:"Unknown"},{value:"0",label:"0"},{value:"I",label:"I"},{value:"II",label:"II"},{value:"III",label:"III"},{value:"IV",label:"IV"}] },
      { name: "diagnosis_date", label: "Diagnosis Date",       type: "date" }
    ],
    statusOptions: [
      { value: "active",     label: "Active",     class: "hms-badge-warning" },
      { value: "remission",  label: "Remission",  class: "hms-badge-success" },
      { value: "recurrence", label: "Recurrence", class: "hms-badge-danger" },
      { value: "palliative", label: "Palliative", class: "hms-badge-purple" },
      { value: "deceased",   label: "Deceased",   class: "hms-badge-danger" },
      { value: "lost",       label: "Lost",       class: "hms-badge-danger" }
    ]
  },

  // ----- DIABETES -----
  {
    type:        "diabetes",
    title:       "Diabetes",
    description: "Type 1, Type 2, gestational — HbA1c & complications",
    icon:        "mdi mdi-water-percent",
    color:       "#16a085",
    listFn:      "getDiabetesPatients",
    enrollFn:    "enrollDiabetes",
    dataKey:     "Patients",
    idField:     "diabetes_id",
    numberField: "diabetes_number",
    columns: [
      { key: "patient_name",       label: "Patient",     type: "patient" },
      { key: "diabetes_number",    label: "DM No",       type: "mono" },
      { key: "diabetes_type",      label: "Type" },
      { key: "diagnosis_date",     label: "Dx Date",     type: "date" },
      { key: "last_hba1c",         label: "Last HbA1c" },
      { key: "last_fasting_sugar", label: "Last FBS" },
      { key: "next_visit_date",    label: "Next Visit",  type: "date" },
      { key: "status",             label: "Status",      type: "status" }
    ],
    enrollFields: [
      { name: "diabetes_number", label: "DM Number",     type: "text" },
      { name: "diabetes_type",   label: "Type *",        type: "select",
        options: [{value:"type1",label:"Type 1"},{value:"type2",label:"Type 2"},{value:"gestational",label:"Gestational"},{value:"mody",label:"MODY"},{value:"other",label:"Other"}] },
      { name: "diagnosis_date",  label: "Diagnosis Date", type: "date" },
      { name: "current_regimen", label: "Current Regimen", type: "text" }
    ],
    statusOptions: [
      { value: "active",       label: "Active",       class: "hms-badge-info" },
      { value: "controlled",   label: "Controlled",   class: "hms-badge-success" },
      { value: "uncontrolled", label: "Uncontrolled", class: "hms-badge-danger" },
      { value: "lost",         label: "Lost",         class: "hms-badge-danger" },
      { value: "deceased",     label: "Deceased",     class: "hms-badge-danger" },
      { value: "transferred",  label: "Transferred",  class: "hms-badge-warning" }
    ]
  },

  // ----- DIALYSIS -----
  {
    type:        "dialysis",
    title:       "Dialysis",
    description: "ESRD / CKD haemodialysis & peritoneal dialysis",
    icon:        "mdi mdi-water-pump",
    color:       "#2980b9",
    listFn:      "getDialysisPatients",
    enrollFn:    "enrollDialysis",
    dataKey:     "Patients",
    idField:     "dialysis_id",
    numberField: "dialysis_number",
    columns: [
      { key: "patient_name",       label: "Patient",       type: "patient" },
      { key: "dialysis_number",    label: "Dial No",       type: "mono" },
      { key: "ckd_stage",          label: "CKD Stage" },
      { key: "dialysis_type",      label: "Type" },
      { key: "access_type",        label: "Access" },
      { key: "sessions_per_week",  label: "Sessions/wk" },
      { key: "next_session_date",  label: "Next Session",  type: "date" },
      { key: "status",             label: "Status",        type: "status" }
    ],
    enrollFields: [
      { name: "dialysis_number",   label: "Dialysis Number", type: "text" },
      { name: "ckd_stage",         label: "CKD Stage",       type: "select",
        options: [{value:"1",label:"1"},{value:"2",label:"2"},{value:"3a",label:"3a"},{value:"3b",label:"3b"},{value:"4",label:"4"},{value:"5",label:"5"}] },
      { name: "dialysis_type",     label: "Type",            type: "select",
        options: [{value:"haemodialysis",label:"Haemodialysis"},{value:"peritoneal",label:"Peritoneal"},{value:"capd",label:"CAPD"}] },
      { name: "access_type",       label: "Access Type",     type: "text" },
      { name: "sessions_per_week", label: "Sessions/Week",   type: "number" },
      { name: "primary_cause",     label: "Primary Cause",   type: "text" }
    ],
    statusOptions: [
      { value: "active",        label: "Active",        class: "hms-badge-success" },
      { value: "transplanted",  label: "Transplanted",  class: "hms-badge-info" },
      { value: "deceased",      label: "Deceased",      class: "hms-badge-danger" },
      { value: "transferred",   label: "Transferred",   class: "hms-badge-warning" },
      { value: "discontinued",  label: "Discontinued",  class: "hms-badge-neutral" }
    ]
  },

  // ----- MENTAL HEALTH -----
  {
    type:        "mental-health",
    title:       "Mental Health",
    description: "Psychiatric care, risk assessment, follow-up",
    icon:        "mdi mdi-brain",
    color:       "#8e44ad",
    listFn:      "getMentalHealthPatients",
    enrollFn:    "enrollMentalHealth",
    dataKey:     "Patients",
    idField:     "mh_id",
    numberField: "mh_number",
    columns: [
      { key: "patient_name",        label: "Patient",      type: "patient" },
      { key: "mh_number",           label: "MH No",        type: "mono" },
      { key: "primary_diagnosis",   label: "Diagnosis" },
      { key: "icd_code",            label: "ICD" },
      { key: "risk_level",          label: "Risk" },
      { key: "suicide_risk",        label: "Suicide Risk" },
      { key: "next_review_date",    label: "Next Review",  type: "date" },
      { key: "status",              label: "Status",       type: "status" }
    ],
    enrollFields: [
      { name: "mh_number",            label: "MH Number",            type: "text" },
      { name: "primary_diagnosis",    label: "Primary Diagnosis *",  type: "text" },
      { name: "icd_code",             label: "ICD-10 Code",          type: "text" },
      { name: "admission_type",       label: "Admission Type",       type: "select",
        options: [{value:"voluntary",label:"Voluntary"},{value:"involuntary",label:"Involuntary"}] },
      { name: "risk_level",           label: "Risk Level",           type: "select",
        options: [{value:"low",label:"Low"},{value:"moderate",label:"Moderate"},{value:"high",label:"High"},{value:"very_high",label:"Very High"}] },
      { name: "suicide_risk",         label: "Suicide Risk",         type: "select",
        options: [{value:"none",label:"None"},{value:"low",label:"Low"},{value:"moderate",label:"Moderate"},{value:"high",label:"High"}] },
      { name: "current_medications",  label: "Current Medications",  type: "text" }
    ],
    statusOptions: [
      { value: "active",       label: "Active",       class: "hms-badge-info" },
      { value: "stable",       label: "Stable",       class: "hms-badge-success" },
      { value: "in_remission", label: "In Remission", class: "hms-badge-success" },
      { value: "discharged",   label: "Discharged",   class: "hms-badge-neutral" },
      { value: "lost",         label: "Lost",         class: "hms-badge-danger" },
      { value: "deceased",     label: "Deceased",     class: "hms-badge-danger" }
    ]
  },

  // ----- NUTRITION -----
  {
    type:        "nutrition",
    title:       "Nutrition (SAM/MAM)",
    description: "Acute malnutrition treatment & RUTF distribution",
    icon:        "mdi mdi-food-apple",
    color:       "#f1c40f",
    listFn:      "getNutritionPatients",
    enrollFn:    "enrollNutrition",
    dataKey:     "Patients",
    idField:     "nutrition_id",
    numberField: "nutrition_number",
    columns: [
      { key: "patient_name",     label: "Patient",      type: "patient" },
      { key: "nutrition_number", label: "Nut No",       type: "mono" },
      { key: "admission_type",   label: "Type" },
      { key: "muac",             label: "MUAC (cm)" },
      { key: "weight",           label: "Wt (kg)" },
      { key: "whz_score",        label: "WHZ" },
      { key: "next_visit_date",  label: "Next Visit",   type: "date" },
      { key: "status",           label: "Status",       type: "status" }
    ],
    enrollFields: [
      { name: "nutrition_number", label: "Nutrition Number", type: "text" },
      { name: "admission_type",   label: "Admission Type",   type: "select",
        options: [{value:"sam",label:"SAM"},{value:"mam",label:"MAM"},{value:"at_risk",label:"At Risk"}] },
      { name: "muac",             label: "MUAC (cm)",        type: "number" },
      { name: "weight",           label: "Weight (kg)",      type: "number" },
      { name: "height",           label: "Height (cm)",      type: "number" },
      { name: "whz_score",        label: "WHZ Score",        type: "number" },
      { name: "oedema",           label: "Oedema present?",  type: "checkbox" }
    ],
    statusOptions: [
      { value: "active", label: "Active", class: "hms-badge-warning" },
      { value: "exited", label: "Exited", class: "hms-badge-neutral" }
    ]
  }
];

export function getRegistryConfig(type) {
  return REGISTRY_TYPES.find(r => r.type === type) || null;
}
